const resources = {
    pros: 'Pros Mentioned',
    cons: 'Cons Mentioned'
};

module.exports = function getResource(label) {
    return resources[label];
};
